import { LogLevel } from "@azure/msal-browser";

let clientId = process.env.REACT_APP_CLIENT_ID;
let authority = process.env.REACT_APP_AUTHORITY;
let redirectUri = process.env.REACT_APP_REDIRECT_URI;
let postLogoutRedirectUri = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI;
let refersh_token = process.env.REACT_APP_REFRESH_TOKEN;

if(process.env.NODE_ENV === "production" && window.location.href.split(".")[2] === "staging") {    
    clientId = "830b8a62-56ac-4e36-8b68-52a74fdb7953";
    authority = "https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22/";
    redirectUri = "https://atc.lkm.staging.accenture.com";
    postLogoutRedirectUri = "https://atc.lkm.staging.accenture.com";
    refersh_token = "830b8a62-56ac-4e36-8b68-52a74fdb7953";
}

export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: authority,            
        redirectUri: redirectUri,
        postLogoutRedirectUri: postLogoutRedirectUri        
      },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {	
                    return;	
                }
                switch (level) {	
                    case LogLevel.Error:	
                        console.error(message);	
                        return;	
                    case LogLevel.Info:	
                        console.info(message);	
                        return;	
                    case LogLevel.Verbose:	
                        console.debug(message);	
                        return;	
                    case LogLevel.Warning:	
                        console.warn(message);	
                        return;	
                    default:
                        return;
                }
            }
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["openid","profile","email","User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const fetchMsGraph = async (url, accessToken) => {
    const response = await fetch(url, {
    headers: {
    Authorization: `Bearer ${accessToken}`,
    },
    });
           
    return response.json();
    };
    export const AUTH_REQUESTS = {
      LOGIN: {
      scopes: ['openid', 'profile'],
      },
      EMAIL: {
      scopes: [],
      },
      REFRESH_TOKEN: {
      scopes: [refersh_token],
      },
      };